// Shared by the visitors and the single guide: visibility does not depend on
// which ordinary section happens to be nearest the viewport's centre.
export function isSkyChasePhase(phase: string | null | undefined) {
  return ["shoo", "sweep-right", "sweep-left", "fleeing"].includes(phase || "");
}

export function getSkyChaseGeometry(
  section: Element,
  viewport: { top: number; bottom: number },
  preferredSize: number
) {
  const gap = section.querySelector("[data-sky-visitors]");
  const heading = section.querySelector("#sky-discovery-title");
  if (!gap || !heading) return null;

  // The lazy comic above initially has zero height. Do not mistake that
  // temporary layout for a visible visit before the illustration has loaded.
  const previousPicture = section.previousElementSibling?.querySelector("img");
  if (previousPicture && !previousPicture.complete) return null;

  const rect = gap.getBoundingClientRect();
  const visibleHeight =
    Math.min(rect.bottom, viewport.bottom) - Math.max(rect.top, viewport.top);
  if (visibleHeight < 24) return null;

  // Leave space for the existing flight's lift and tilt, not just the drawing
  // at rest. The lower edge is the real heading, not the picture's upper edge.
  const top = viewport.top + 36;
  const bottom =
    Math.min(viewport.bottom, heading.getBoundingClientRect().top) - 24;
  const size = Math.min(preferredSize, bottom - top);
  if (size < 80) return null;
  return { top, bottom, size };
}
